var chunkMapping = {
	"461": [
		70461
	],
	"545": [
		33545
	],
	"558": [
		50558
	],
	"712": [
		4712
	],
	"754": [
		34754
	],
	"759": [
		40759
	],
	"841": [
		8841
	],
	"925": [
		7925
	],
	"983": [
		55983
	]
};
var idToExternalAndNameMapping = {
	"4712": [
		"default",
		"./mainMenu",
		18073
	],
	"7925": [
		"default",
		"./translations",
		18073
	],
	"8841": [
		"default",
		"./tagsManagement",
		80281
	],
	"33545": [
		"default",
		"./products",
		18073
	],
	"34754": [
		"default",
		"./importDashboard",
		18073
	],
	"40759": [
		"default",
		"./autoInquiries",
		80281
	],
	"50558": [
		"default",
		"./modules",
		18073
	],
	"55983": [
		"default",
		"./dashboard",
		51122
	],
	"70461": [
		"default",
		"./projects",
		51122
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}